import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }            from '../shared/shared.module';
import { WsApiSecretKeyComponent } from './ws-api.secret-key.component';
import { WsApiService }            from './ws-api.service';
import { WsApiSettingsComponent }  from './ws-api.settings.component';
import { WsApiStates }             from './ws-api.states';

@NgModule({
  declarations: [
    WsApiSecretKeyComponent,
    WsApiSettingsComponent
  ],
  entryComponents: [
    WsApiSecretKeyComponent,
    WsApiSettingsComponent
  ],
  imports: [
    SharedModule,

    UIRouterUpgradeModule.forChild({ states: WsApiStates })
  ],
  providers: [
    WsApiService
  ]
})
export class WsApiModule {}
